<template>
    <div>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" color="accent">Procesando</v-progress-circular>
      </v-overlay>
                
                <v-stepper v-model="e1" class="mb-10">
                    <v-stepper-header>
                        <v-stepper-step step="1" :complete="e1 > 1">Enviado</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="2" :complete="e1 > 2">Pendiente</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3" :complete="e1 > 3">En Proceso</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="4" :complete="e1 > 4">En Observación</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="5" :complete="e1 == 5">Finalizado</v-stepper-step>
                    </v-stepper-header>
                </v-stepper>

                <v-divider />
                <v-form ref="form">
                    <v-card variant="flat">
                      <v-card-subtitle class="f-w-800">Orden</v-card-subtitle>
                        <v-card-text>
                          <v-row>
                            <v-col cols="2">
                              <v-text-field
                                  label="Orden Id"
                                  prefix="CMP-"
                                  v-model="RepOrder.RepOrder_id"
                                  placeholder="1"
                                  outlined
                                  readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                label="Descripción"
                                v-model="RepOrder.RepOrder_Desc"
                                placeholder="Descripción"
                                outlined
                                readonly
                                :rules="[v => !!v || 'Descripción requerida']"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Fecha"
                                v-model="RepOrder.CreationRepEvent_Dt"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Usuario"
                                v-model="RepOrder.CreationRepUser_id"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />

                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Proveedores</v-card-subtitle>
                        <v-card-text>
                        <v-sheet rounded="0" border>
                          <v-data-table
                          :headers="headers1"
                          :items="subitems"
                          class="elevation-1"
                          header-class="custom-header"
                        >
                        <template v-slot:item.RepOrderItemsStatus_id="{ item }">
                          <v-chip
                            v-if="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :color="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :border="`${getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color} thin opacity-10`"
                            size="small"
                          >
                            {{ getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Desc }}
                          </v-chip>
                        </template>
                        <template v-slot:item.MotherSupplier_Desc="{ item }">
                          <span>{{ getSupplier(item.MotherSupplier_id).MotherSupplier_Desc }}</span>
                        </template>
                        </v-data-table>
                        </v-sheet>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />
                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Movimientos</v-card-subtitle>
                        <v-card-text>
                      <v-sheet rounded="" border>
                        <v-data-table
                          :headers="headers3"
                          :items="RepOrderItems"
                          class="elevation-1"
                          header-class="custom-header"
                        ></v-data-table>
                    </v-sheet>
                    </v-card-text>
                    </v-card>

                    <v-divider class="my-5" />

                    <v-row justify="end">
                        <v-col cols="6" lg="2" md="6" sm="12" justify="end" class="">
                            <div class="d-flex ga-6 mt-8 justify-end">
                                <v-btn color="secondary" variant="flat" @click="volver">Regresar</v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6" lg="2" md="6" sm="12" justify="end" class="">
                            <div class="d-flex ga-6 mt-8 justify-end">
                                <v-btn @click="onCancel" v-if="e1 < 5" color="primary" variant="outlined">Finalizar</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>

            </div>
  </template>
  
  <script>
  //import XLSX from 'xlsx-style'
  import * as XLSX2 from 'xlsx'
  import { saveAs } from 'file-saver'
  import axios from 'axios'
  import { EventBus } from '@/event-bus'
  import router from '@/router';
  export default {
    data: () => ({
      search: '',
      OrdenId: '',
      newcmp: false,
      e1: 0,
      msj_proceso:'',
      progressBar1: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      listOr: true,
      dialog_new: false,
      btnG: true,
      valid: true,
      valid2: true,
      dialog: false,
      loading2: false,
      filters: {},
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      tabs: 0,
      text: 'Lorem ipsum',
      loading: true,
      taberror: false,
      progressBar: false,
      mostrarTabs: false,
      items: [
        {
          icon: 'mdi-account-box',
          text: 'Destinatarios'
        },
        {
          icon: 'mdi-database',
          text: 'Datos'
        },        
        {
          icon: 'mdi-file-document',
          text: 'Mail'
        },
        {
          icon: 'mdi-alert-circle',
          text: 'Errores'
        }
      ],
      headers: [
        { text: 'Id', title: 'Id', value: 'RepOrder_id', align: 'center', sortable: true, key: 'RepOrder_id' },
        { text: 'Descripción', title: 'Descripción', value: 'RepOrder_Desc', align: 'center', sortable: true, key: 'RepOrder_Desc' },
        { text: 'Estado', title: 'Estado', value: 'RepOrderStatus_id', align: 'center', sortable: true, key: 'RepOrderStatus_id' },
        { text: 'Usuario Actualización', title: 'Usuario Actualización', value: 'LastOpRepUser_id', align: 'center', sortable: true, key: 'LastOpRepUser_id' },
        { text: 'Fecha Act', title: 'Fecha Act', value: 'RepEvent_Dt', align: 'center', sortable: true, key: 'RepEvent_Dt' },
        { text: 'Hora Act', title: 'Hora Act', value: 'RepEvent_Tm', align: 'center', sortable: true, key: 'RepEvent_Tm' },
      ],
      headers1:[
        { text: 'Folio', key: 'MotherSupplier_id',value: 'MotherSupplier_id' },
        { text: 'Desc Proveedor', key: 'MotherSupplier_Desc',value: 'MotherSupplier_Desc' },
        { text: 'Estado', key: 'RepOrderItemsStatus_id',value: 'RepOrderItemsStatus_id' },
        { text: 'Fecha', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
        { text: 'Hora', key: 'RepEvent_Tm',value: 'RepEvent_Tm' }
      ],
      headers2:[],
      headers3:[
        { text: 'N°', key: 'RepOrderItems_id',value: 'RepOrderItems_id' },
        { text: 'Descripción', key: 'RepOrderItems_Desc',value: 'RepOrderItems_Desc' },
        { text: 'Observación', key: 'RepOrderItems_Obs',value: 'RepOrderItems_Obs' },
        { text: 'Fecha', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
        { text: 'Hora', key: 'RepEvent_Tm',value: 'RepEvent_Tm' },
      ],
      ordenes: [
        { orden_id: 101, descripcion: 'Compra materiales A', estado: 'Pendiente' },
        { orden_id: 102, descripcion: 'Compra materiales B', estado: 'Completado' }
      ],
      subitems: [],
      RepOrderItems: [],
      orderStore:[],
      itemsEnTabla:[],
      proveedores: [],
      RepOrderTemplate: [],
      RepOrder:[],
      selectedDescription: '',
      destinatarios:[],
      data2:[],
      errores: [],
      token: sessionStorage.getItem('access_token'),
      user: sessionStorage.getItem('ApiUser_id'),
      hora: '',
      fechaHoy: new Date().toISOString().split('T')[0],
      editedIndex: -1,
      RepOrderTemplate2: {
        RepOrderTemplate2_id: 0
      },
      serverItems:[],
      filters: {
        RepGroup_id: '',
        EffectiveDate: '',
        ExpirationDate: '',
        LastOpRepUser_id: '',
        RepEvent_Dt: '',
        RepEvent_Tm: ''
      },
      files:[],
      OrdenItem: {
        RepOrder_id: '',
        RepOrder_Desc: '',
        RepOrder_Text: '',
        RepOrderStatus_id: '1',
        CreationRepEvent_id: this.token,
        CreationRepUser_id: this.user,
        CreationRepEvent_Dt: this.fechaHoy,
        CreationRepEvent_Tm: '',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: ''
      },
      editedItem:{
        ApiUser_id: '',
        ApiUser_GivenName: '',
        ApiUser_EMail: '',
        ApiUserType_id: 'P'
      },
      editedItemS: {
        ApiUser_id:'',
        ApiUser_Supplier:'',
        SupplierStart_Dt: new Date().toISOString().split('T')[0], 
        SupplierEnd_Dt: '9999-12-31'
      },
      RepOrderStatus:[],
      RepOrderItemsStatus:[],
      ReceiversItem: {
        MotherSupplier_id: '',
        RepOrder_id: '',
        RepOrderGroupReceivers_id: '',
        RepOrderItemsStatus_id: '1',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: ''
      },
      idRules: [
        v => !!v || 'Rol ID es requerido',
        v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
      ],
      descRules: [
        v => !!v || 'Descripcion es requerida',
        v => (v && v.length <= 61) || 'Descripcion debe tener menos de 30 caracteres',
      ],
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'El correo debe tener un formato válido'
      ],
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
    mounted() {
      this.OrdenId = this.$route.params.id;
      this.loading = true
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Proceso' : 'Editar Proceso'
      },
      destinatariosConClave() {
        // Devolvemos una copia con el idCompuesta SOLO PARA LA VISTA
        return this.destinatarios.map(item => ({
          ...item,
          idCompuesta: `${item.ApiUser_id}_${item.ApiUser_Supplier}`,
        }))
      },
      filteredItems() {
        if (!this.RepOrder || !Array.isArray(this.RepOrder)) return [];

        return this.RepOrder.filter(item => {
          return Object.keys(this.filters).every(key => {
            const filterValue = this.filters[key];
            if (!filterValue) return true;

            let itemValue = item[key];

            // Manejo especial para campos con descripción asociada
            if (key === 'RepOrderStatus_id') {
              const status = this.getRepOrderStatus(item.RepOrderStatus_id);
              itemValue = status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : '';
            }

            if (itemValue == null) return false;

            return itemValue.toString().toLowerCase().includes(filterValue.toLowerCase());
          });
        });
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      },
      'ReceiversItem.MotherSupplier_id'(nuevosIds) {
        // Actualiza la tabla con los proveedores seleccionados
        this.proveedores = this.proveedores.map(item => ({
          ...item,
          RepOrder_id: this.OrdenItem.RepOrder_id
        }));
        this.itemsEnTabla = this.proveedores.filter(p =>
          nuevosIds.includes(p.MotherSupplier_id)
        );
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {
      exportarExcelCarga() {
        const Archivo = "Resultado_Carga_CMP"+this.OrdenItem.RepOrder_id+"_"+this.fechaHoy
        
        const sheets = [
          {
            nombre: 'Destinatarios',
            headers: this.headers1,
            data: this.destinatarios
          },
          {
            nombre: 'Data',
            headers: this.headers2,
            data: this.data2
          },
          {
            nombre: 'Errores',
            headers: this.headers3,
            data: this.errores
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },
      exportarExcelOrdenes() {
        const Archivo = "CMP-"+this.fechaHoy
        const filteredIds = this.filteredItems.map(item => item.RepOrder_id)
        const subitemsData = this.subitems.filter(sub => filteredIds.includes(sub.RepOrder_id))
        const subitemsData2 = subitemsData.map(sub => {
          const status = this.getRepOrderItemsStatus(sub.RepOrderItemsStatus_id)
          const status2 = this.getSupplier(sub.MotherSupplier_id)
          return {
            ...sub,
            status_desc: status && status.RepOrderItemsStatus_Desc ? status.RepOrderItemsStatus_Desc : '',
            MotherSupplier_Desc: status2 && status2.MotherSupplier_Desc ? status2.MotherSupplier_Desc : ''
          }
        })
        const OrdItem = this.filteredItems.map(sub => {
          const status = this.getRepOrderStatus(sub.RepOrderStatus_id)
          return {
            ...sub,
            RepOrderStatus_id: status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : ''
          }
        })
        console.log(OrdItem)
        const subheader=[
          { text: 'Orden ID', title: 'Orden ID', value: 'RepOrder_id', key: 'RepOrder_id'},
          { text: 'Proveedor', title: 'Proveedor', value: 'MotherSupplier_id', key: 'MotherSupplier_id'},
          { text: 'Proveedor Desc', title: 'Proveedor Desc', value: 'MotherSupplier_Desc', key: 'MotherSupplier_Desc'},
          { text: 'Status', title: 'Status', value: 'status_desc', key: 'status_desc'},
          { text: 'Fecha Status', title: 'Fecha Status', value: 'RepEvent_Dt', key: 'RepEvent_Dt'},
          { text: 'Hora Status', title: 'Hora Status', value: 'RepEvent_Tm', key: 'RepEvent_Tm'}
        ]
        const sheets = [
          {
            nombre: 'CMP',
            headers: this.headers,
            data: OrdItem
          },
          {
            nombre: 'Detalle',
            headers: subheader,
            data: subitemsData2
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },
      exportDataExcel(multipleSheets, Archivo) {
        const wb = XLSX2.utils.book_new()

        multipleSheets.forEach(sheet => {
          if (!Array.isArray(sheet.data) || sheet.data.length === 0) return

          const headers = sheet.headers.map(h => h.text)
          const rows = sheet.data.map(row =>
            sheet.headers.map(h => {
              const val = row[h.value]
              return val != null ? val : ''
            })
          )

          const ws = XLSX2.utils.aoa_to_sheet([headers, ...rows])

          // Estilos para los encabezados (fila 1)
          headers.forEach((_, colIndex) => {
            const cellRef = XLSX2.utils.encode_cell({ c: colIndex, r: 0 })
            if (!ws[cellRef]) return
            ws[cellRef].s = {
              font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
              fill: { fgColor: { rgb: "007ACC" } },
              alignment: { horizontal: "center", vertical: "center" },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
              }
            }
          })

          // Ajustar ancho columnas según longitud del header
          ws['!cols'] = headers.map(h => ({ wch: Math.max(10, h.length) }))

          XLSX2.utils.book_append_sheet(wb, ws, sheet.nombre || 'Hoja')
        })

        const wbout = XLSX2.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true })
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), Archivo + '.xlsx')
      },
      getFilterKey(column) {
        return column.title === 'Estado' ? 'RepOrderStatus_Desc' : column.value;
      },
      customFilter(value, search, item, column) {
        if (!search) return true;
          const lowerSearch = search.toLowerCase();

          if (column.value === 'RepOrderStatus_id') {
            const status = this.getRepOrderStatus(item.RepOrderStatus_id);
            const desc = status && status.RepOrderStatus_Desc
              ? status.RepOrderStatus_Desc.toLowerCase()
              : '';
            return desc.includes(lowerSearch);
          }

          return String(value).toLowerCase().includes(lowerSearch);
      },
      toggleSeleccionarTodo() {
        this.destinatarios.forEach(item => {
          item.selected = this.selectAll;
        });
      },
      mostrarProveedor(item) {
        if (!item) return ''
        return `${item.MotherSupplier_id} - ${item.MotherSupplier_Desc}`
      },
      getItemKey(item) {
        return `${item.ApiUser_id}_${item.ApiUser_Supplier}`;
      },
      generarUsuario() {
        const val = this.editedItem.ApiUser_GivenName
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") // quitar acentos
          .replace(/[^a-z\s]/g, ""); // quitar símbolos

        const partes = val.split(/\s+/);

        if (partes.length >= 2) {
          const primero = partes[0];
          const ultimo = partes[partes.length - 1];
          const numero = Math.floor(0 + Math.random() * 99999999); // número aleatorio
          this.editedItem.ApiUser_id = `${primero}_${ultimo}_${numero}`;
          this.editedItemS.ApiUser_id = `${primero}_${ultimo}_${numero}`;
        } else {
          this.editedItemS.ApiUser_id = '';
          this.editedItem.ApiUser_id = '';
        }
      },
      nombreCompleto() {
        const val = this.editedItem.ApiUser_GivenName
        const partes = val
          .trim()
          .toLowerCase()
          .normalize("NFD") // Quita acentos
          .replace(/[\u0300-\u036f]/g, "") // Quita caracteres diacríticos
          .split(/\s+/)

        if (partes.length >= 2) {
          const primero = partes[0]
          const ultimo = partes[partes.length - 1]
          const numero = Math.floor(0 + Math.random() * 99999999)
          this.editedItem.ApiUser_id = `${numero}`
          this.editedItemS.ApiUser_id = `${numero}`
        } else {
          this.editedItem.ApiUser_id = ''
          this.editedItemS.ApiUser_id = ''
        }
      },
      exportData() {
        const headersCsv = this.headers.map(header => header.title).join(',')
        const rows = this.filteredItems.map(item =>this.headers.map(header => item[header.value]).join(','))
        
        const csvContent = [headersCsv, ...rows].join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'datos_exportados.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      initialize () {

        EventBus.$emit('actualizarNotificaciones')

        this.destinatarios = []
        this.data2 = []
        this.errores = []
        this.files = []
        this.tabs = 0
        this.RepOrderTemplate2.RepOrderTemplate2_id = 0
        this.mostrarTabs = false

        this.OrdenItem.RepOrder_id = ''
        this.OrdenItem.RepOrder_Desc= ''
        this.OrdenItem.RepOrder_Text= ''
        this.OrdenItem.RepOrderStatus_id= '1'
        this.OrdenItem.CreationRepEvent_id= this.token
        this.OrdenItem.CreationRepUser_id= this.user
        this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
        this.OrdenItem.CreationRepEvent_Tm= ''
        this.OrdenItem.RepEvent_id= this.token
        this.OrdenItem.LastOpRepUser_id= this.user
        this.OrdenItem.RepEvent_Dt= this.fechaHoy
        this.OrdenItem.RepEvent_Tm= ''

        this.editedItem.ApiUser_id= '',
        this.editedItem.ApiUser_GivenName= '',
        this.editedItem.ApiUser_EMail= '',
        this.editedItem.ApiUserType_id= 'P'

        this.editedItemS.ApiUser_id='',
        this.editedItemS.ApiUser_Supplier='',
        this.editedItemS.SupplierStart_Dt= this.fechaHoy, 
        this.editedItemS.SupplierEnd_Dt= '9999-12-31'

        this.ReceiversItem.RepEvent_id= this.token
        this.ReceiversItem.LastOpRepUser_id= this.user
        this.ReceiversItem.RepEvent_Dt= this.fechaHoy
        this.listOr = true
        this.loading2 = false
        this.loading = true
        this.newcmp = false
        const filter = {
          RepOrder_id: this.$route.params.id
        }

        axios.post(this.api_tool_url + '/get_RepOrder', filter, this.config)
        .then(response => {
          this.RepOrder = response.data.ResultRows[0]
          this.e1 = parseInt(this.RepOrder.RepOrderStatus_id)
        })
        .catch(error => {
          this.RepOrder = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderGroupReceivers', filter, this.config)
        .then(response => {
          this.subitems = response.data.ResultRows
        })
        .catch(error => {
          this.subitems = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderItems', filter, this.config)
        .then(response => {
          this.RepOrderItems = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItems = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderItemsStatus', {}, this.config)
        .then(response => {
          this.RepOrderItemsStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItemsStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderStatus', {}, this.config)
        .then(response => {
          this.RepOrderStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderTemplate', {}, this.config)
        .then(response => {
          this.RepOrderTemplate = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderTemplate = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_MotherSupplier', {}, this.config)
        .then(response => {
          this.proveedores = response.data.ResultRows
          this.loading = false
        })
        .catch(error => {
          this.proveedores = []
          alert(error.response.data.message)
        })

        this.loading = false
      },

      updateDescription() {
        const item = this.RepOrderTemplate.find(t => t.RepOrderTemplate_id === this.RepOrderTemplate2.RepOrderTemplate2_id);
        this.OrdenItem.RepOrder_Text = item ? item.RepOrderTemplate_Text : '';
      },
      newtItem() {
        this.dialog = true
      },
      // agregarProducto() {
      //   const item = this.proveedores.find(p => p.id === this.selectedItemToAdd);
      //   if (item && !this.itemsEnTabla.find(p => p.id === item.id)) {
      //     this.itemsEnTabla.push(item)
      //   }
      // },
      agregarNuevo(){
        this.newcmp = true
        this.listOr = false
      },
      listaCMP(){
        this.newcmp = false
        this.listOr = true
        this.initialize()
      },
      getTemplate(statusId) {
        return this.RepOrderTemplate.find(s => s.RepOrderTemplate_id === statusId) || {}
      },
      getSupplier(statusId) {
        return this.proveedores.find(s => s.MotherSupplier_id === statusId) || {}
      },
      getRepOrderStatus(statusId) {
        return this.RepOrderStatus.find(s => s.RepOrderStatus_id === statusId) || {}
      },
      getRepOrderItemsStatus(statusId) {
        return this.RepOrderItemsStatus.find(s => s.RepOrderItemsStatus_id === statusId) || {}
      },
      getSubitems(orden_id) {
        return this.subitems.filter(sub => sub.RepOrder_id === orden_id)
      },
      save () {
        this.editedItem.ApiUserType_id = 'P'
        this.loading2 = true
        axios.post(this.api_tool_url + '/ins_user', this.editedItem, this.config)
        .then(response => {
          if(response.data.ResultRows.length >= 1){
            axios.post(this.api_tool_url + '/upd_ins_userMotherSupplier', this.editedItemS, this.config)
            .then(response => {
              this.close()
            })
            .catch(error => {
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
          alert(error.response.data.message)
        })
      },
      volver() {
        router.replace({
          name: 'CMPSolicitud',
          params: {
            token: this.token
          }
        });
      },
      onCancel(){
        const filter = {
          token: this.token,
          cmp_id: this.RepOrder.RepOrder_id,
          user: this.user
        }
        this.loading = true
        axios.post(this.api_tool_url + '/finalizar_orden', filter, this.config)
        .then(response => {
          if(response.data.ResultRows.length > 0){
            this.RepOrder = response.data.ResultRows[0]
            this.e1 = parseInt(this.RepOrder.RepOrderStatus_id)

            const filter2 = {
              RepOrder_id: this.RepOrder.RepOrder_id
            }

            axios.post(this.api_tool_url + '/get_RepOrderItems', filter2, this.config)
            .then(response => {
              this.RepOrderItems = response.data.ResultRows
              this.loading = false
            })
            .catch(error => {
              this.RepOrderItems = []
              this.loading = false
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
            alert(error.response.data.message)
        })

      },
      carga() {
        this.btn = true
        this.progressBar = true
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let data = new FormData();
        this.mvm = []
        this.destinatarios = []
        this.headers2 = []
        this.data2 = []
        this.errores = []
        this.Observaciones = []
        this.tabs = 0
        this.taberror = false
        this.mostrarTabs = false
        data.append('file', document.getElementById('file').files[0]);
        data.append('token', this.token);
        data.append('cmp_id', this.OrdenItem.RepOrder_id);
        data.append('user', this.user);
        
        axios.post(this.api_tool_url + '/fileUploadCMP', data, this.config)
        .then(response => {
          this.headers2 = response.data.ResultHeader
          if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {
            this.destinatarios = response.data.ResultUsers
            this.destinatarios.forEach(item => {
              this.$set(item, 'selected', false); // necesario para que Vue lo reactive
              this.$set(item, 'idCompuesta', `${item.ApiUser_id}_${item.ApiUser_Supplier}`);
            });
            this.headers2 = response.data.ResultHeader
            this.data2 = response.data.ResultRows
            this.errores =  response.data.ResultError
            if(response.data.ResultError.length > 0  ){
              this.tabs = 3
              this.taberror = true
            }
            this.Observaciones= response.data.ResultError
            this.mostrarTabs = true
            this.progressBar = false
            this.btnG = false
            
            this.msj_proceso = 'Se realizo la comunicación correctamente.'
          }
          else {
            this.progressBar = false
            this.loading = false
            this.msj_proceso = error
          }
          this.btn = false
        })
        .catch(error => {
          this.btn = false
          this.progressBar = false
          if (error.response && error.response.data && error.response.data.message) {
            this.msj_proceso = error.response.data.message;
          } 
          else 
          {
            this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
          }
          this.active = true
        })
                    
                    
      },
      generar(){
        this.newcmp = false
        this.listOr = true
        this.loading = true
      },
      editItem (item) {
        this.editedIndex = this.RepOrderProcess.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
  
      deleteItem (item) {
        const index = this.RepOrderProcess.indexOf(item)
        confirm('¿Confirma la eliminación del registro?') && this.deleteUserMenu(index)
      },
  
      deleteUserMenu(index) {
        let usermenus_tmp = this.RepOrderProcess[index]
        //delete usermenus_tmp.RepOrderProcess_id
        axios.post(this.api_tool_url + '/del_RepOrderProcess', usermenus_tmp, this.config)
          .then(response => {
            this.RepOrderProcess.splice(index, 1)
            this.close()
            })
          .catch(error => {
            this.RepOrderProcess = []
            alert(error.response.data.message)
            })
      },
  
      close () {
        this.dialog = false
        this.dialog_new = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
  
      GenerarCMP() {
        
        this.dialog_new = true
        const ahora = new Date();
        const horas = ahora.getHours().toString().padStart(2, '0');
        const minutos = ahora.getMinutes().toString().padStart(2, '0');
        const segundos = ahora.getSeconds().toString().padStart(2, '0');
        this.hora = `${horas}:${minutos}:${segundos}`;

        this.OrdenItem.RepEvent_Tm = this.hora
        const RepOrderTemplate_Descr = this.getTemplate(this.RepOrderTemplate2.RepOrderTemplate2_id).RepOrderTemplate_Desc
        const folios_new  = this.destinatarios.filter(item => item.selected === true)
        
        const proveedoresUnicos = Array.from(
                      new Map(folios_new.map(p => [p.ApiUser_Supplier, p])).values()
        );

        const filter = {
          RepOrder_id: this.OrdenItem.RepOrder_id,
          RepEvent_id: this.token,
          LastOpRepUser_id: this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName,
          RepEvent_Dt: this.fechaHoy,
          RepEvent_Tm: this.hora,
          RepOrder: this.OrdenItem,
          RepOrderGroupReceivers: this.destinatarios.filter(item => item.selected === true),
          RepOrderData: this.data2,
          Header: this.headers2,
          RepOrderTemplate_Desc: RepOrderTemplate_Descr
        }

        this.e1 = 1
        this.progressBar1 = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"

        axios.post(this.api_tool_url + '/SendCMP', filter, this.config)
        .then(response => {
          if(response.data.ResultRows === 'OK'){
            this.e1 = 1
            this.step_color1 = "#008000"
            this.step_error1 = true
            this.progressBar1 = false
            this.msj_proceso = 'Se registro la comunicación correctamente.'
            this.e1 = 2
            this.progressBar1 = true
            
            axios.post(this.api_tool_url + '/SendMailCMP', filter, this.config)
            .then(response => {
              if(response.data.ResultRows === 'OK') {
                this.e1 = 2
                this.step_color2 = "#008000"
                this.progressBar1 = false
                this.step_error2 = true
                this.msj_proceso = 'Se registraron los destinatarios correctamente.'
                
                this.e1 = 3
                this.progressBar1 = true
                this.msj_proceso = 'Finalizando Comunicación.'

                const filter2 = {RepOrder_id: this.OrdenItem.RepOrder_id}
                
                axios.post(this.api_tool_url + '/get_RepOrder', filter2, this.config)
                .then(response => {
                  if (response.data.ResultRows.length > 0){
                    this.e1 = 3
                    this.step_color3 = "#008000"
                    this.progressBar1 = false
                    this.step_error3 = true
                    this.msj_proceso = 
                    `Finalizo el envío de la comunicación.\n` +
                    `Orden de CMP: ${this.OrdenItem.RepOrder_id} - ${this.OrdenItem.RepOrder_Desc}.\n`
                    //  +`Proveedores:\n` +proveedoresUnicos.map(p => `\t${p.ApiUser_Supplier} - ${p.MotherSupplier_Desc}`).join('\n');
                    this.destinatarios = []
                    this.data2 = []
                    this.errores = []
                    this.files = []
                    this.tabs = 0
                    this.RepOrderTemplate2.RepOrderTemplate2_id = 0
                    this.mostrarTabs = false

                    this.OrdenItem.RepOrder_id = ''
                    this.OrdenItem.RepOrder_Desc= ''
                    this.OrdenItem.RepOrder_Text= ''
                    this.OrdenItem.RepOrderStatus_id= '1'
                    this.OrdenItem.CreationRepEvent_id= this.token
                    this.OrdenItem.CreationRepUser_id= this.user
                    this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
                    this.OrdenItem.CreationRepEvent_Tm= ''
                    this.OrdenItem.RepEvent_id= this.token
                    this.OrdenItem.LastOpRepUser_id= this.user
                    this.OrdenItem.RepEvent_Dt= this.fechaHoy
                    this.OrdenItem.RepEvent_Tm= ''

                    this.editedItem.ApiUser_id= '',
                    this.editedItem.ApiUser_GivenName= '',
                    this.editedItem.ApiUser_EMail= '',
                    this.editedItem.ApiUserType_id= 'P'

                    this.editedItemS.ApiUser_id='',
                    this.editedItemS.ApiUser_Supplier='',
                    this.editedItemS.SupplierStart_Dt= new Date().toISOString().split('T')[0], 
                    this.editedItemS.SupplierEnd_Dt= '9999-12-31'

                    this.initialize()
                    EventBus.$emit('actualizarNotificaciones')

                  }
                  else{
                    this.e1 = 3
                    this.step_color3 = "#C0392B"
                    this.step_error3 = false
                    this.progressBar1 = false
                    this.msj_proceso = 'Fallo la finalización de la orden.'
                  }
                })
                .catch(error => {
                  this.e1 = 3
                  this.step_color3 = "#C0392B"
                  this.step_error3 = false
                  this.progressBar1 = false
                  this.msj_proceso = 'Fallo la finalización de la orden.'
                  alert(error.response.data.message)
                })
                
              }
              else{
                this.e1 = 2
                this.step_color2 = "#C0392B"
                this.step_error2 = false
                this.progressBar1 = false
                this.msj_proceso = 'Fallo el registro de destinatarios.'
              }

            })
            .catch(error => {
              this.e1 = 2
              this.step_color2 = "#C0392B"
              this.step_error2 = false
              this.progressBar1 = false
              this.msj_proceso = 'Fallo el registro de destinatarios.'
              alert(error.response.data.message)
            })
          }
          else{
            this.e1 = 1
            this.step_color1 = "#C0392B"
            this.step_error1 = false
            this.progressBar1 = false
            this.msj_proceso = 'Fallo el registro la comunicación. '
            alert(response.data.ResultError)
          } 
        })
        .catch(error => {
          this.e1 = 1
          this.step_color1 = "#C0392B"
          this.step_error1 = false
          this.progressBar1 = false
          this.msj_proceso = 'Fallo el registro la comunicación.'
          alert(error.response.data.message)
        })
        
      }
    }
  }
  </script>
  
  <style scoped>
  .custom-header {
    background-color: #1976d2; /* Azul Vuetify */
    color: white;
    font-weight: bold;
    text-transform: uppercase;
  }
  .tab-active {
  color: red !important;
  }
  .tab-inactive {
    color: black !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/RepOrderView.vue